import { LoadingButton } from "@mui/lab";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Slide, IconButton, DialogContentText } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../store/hooks/hooks";
import { StudentActions } from "../../../../store/StudentAction";
import { TransitionProps } from "@mui/material/transitions";
import { createNotifictions } from "../../../../utils/helperFunction";
import moment from "moment";
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import AdminApi from "../../../../store/services/admin";
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import { useNavigate } from "react-router-dom";
const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const RequestDetailsModal = (props: any) => {
    const [open, setOpen] = React.useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    useEffect(() => {
        handleClose()
    }, [isLoading])
    const notifications = (req: any, status: string) => {
        switch (req.code) {
            case 'CP':
                createNotifictions({
                    target: req.Student.studentId,
                    message: `Placement change request has been ${status === "1" ? "Approved" : "Rejected"}`,
                    type: "RQ",
                })
                return
            case 'DR':
                createNotifictions({
                    target: req.Student.studentId,
                    message: `Placement date change request has been ${status === "1" ? "Approved" : "Rejected"}`,
                    type: "RQ",
                })
                return
            case 'LR':
                createNotifictions({
                    target: req.Student.studentId,
                    message: `Leave request from ${moment(req.details.leaveFrom).format('D/MM/YYYY')} - ${moment(req.details.leaveTo).format('D/MM/YYYY')} is ${status === "1" ? "Approved" : "Rejected"}`,
                    type: "RQ",
                })
                return

        }

    }
    const changeRequestStatus = () => {
        setIsLoading(true)
        if (props.req.id) {
            let body = {
                id: props.req.id,
                status: props.status
            }
            AdminApi.changeRequest(body).then(res => {
                dispatch(StudentActions.setMessage(`Request ${props.status === "1" ? "Approved" : "Rejected"}`))
                notifications(props.req, props.status)
                props.changeStatus()
            }).catch((e) => {
                console.log(e)
                if (e.response.status === 403) {
                    navigate('/login')
                }
                dispatch(StudentActions.setMessage("Request Updation Failed.Try again."))
            })
        }
        else {
            setIsLoading(false)
            dispatch(StudentActions.setMessage("Request Updation Failed.Try again."))
        }

    }

    return (
        <div>
            <IconButton aria-label="approve" size="medium" onClick={handleClickOpen}>
                {
                    props.status === "1" ? <CheckCircleRoundedIcon className='checkText' fontSize="inherit" /> : <CancelRoundedIcon className='rejectText' fontSize="inherit" />
                }

            </IconButton>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {`Are you sure to ${props.status === "1" ? "Approve" : "Reject"} the request `}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>No</Button>
                    <LoadingButton
                        loading={isLoading}
                        loadingPosition="start"
                        onClick={changeRequestStatus}
                        startIcon={<CheckRoundedIcon />}
                        variant="contained"
                    >
                        Yes
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </div>
    )

}
export default RequestDetailsModal;